let Vue = require('vue').default;
var axios = require('./common').axios;
let snotify = require('vue-snotify');
let snotifyMixin = require('./components/snotifyMixin.js').default;

Vue.use(snotify.default);

module.exports = function(context) {
    return new Vue({
        el: '.registration-form',
        data: {
            user: context,
            validationState: {},
            wasValidated: false,
            successfullySubmited: false
        },
        mixins: [snotifyMixin],
        methods: {
            onSubmit: function () {
                var vm = this;
                axios.post('/auth/register/', this.user)
                    .then(function (response) {
                        if (response.status == 200) {
                            vm.successfullySubmited = true;
                        }  
                    })
                    .catch(function (error) {
                        var body = error.response.data;
                        vm.wasValidated = true;
                        if (body.state)
                            vm.$set(vm, "validationState", body.state);
                        if (body.state.general)
                            vm.showError('Server Error', body.state.general);
                    });
            }
        }
    });
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}